// src/user/services/api/assets.js

import { apiRequest, buildUrl } from './index';

/**
 * Assets API service
 * Handles all asset-related API calls
 */

/**
 * Fetch asset details by access key
 * @param {string} accessKey - The access key for the asset
 * @param {AbortSignal} [signal] - Optional abort signal
 * @returns {Promise<Object>} Asset data
 */
function assetByAccessKeyUrl(accessKey, { fieldEngineerId } = {}) {
  const base = `/v1/assets/access_key/${encodeURIComponent(accessKey)}.json`;
  if (!fieldEngineerId) return buildUrl(base);
  const params = new URLSearchParams({ field_engineer_id: String(fieldEngineerId) });
  return buildUrl(`${base}?${params.toString()}`);
}

export async function fetchAssetByAccessKey(accessKey, { signal, fieldEngineerId } = {}) {
  const url = assetByAccessKeyUrl(accessKey, { fieldEngineerId });
  return apiRequest(url, { signal });
}

/**
 * Fetch and validate access for an access key
 * @param {string} accessKey - The access key to validate
 * @param {AbortSignal} [signal] - Optional abort signal
 * @returns {Promise<Object>} Access validation data
 */
export async function validateAccess(accessKey, { signal, fieldEngineerId } = {}) {
  const url = assetByAccessKeyUrl(accessKey, { fieldEngineerId });
  return apiRequest(url, { signal });
}
